export default [
  {
    path: '/experience_organizations',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'experience-organizations' */ '@/views/experience_organizations/List.vue')
  },
  {
    path: '/experience_organizations/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'experience-organizations' */ '@/views/experience_organizations/ExperienceOrganization.vue'),
    props: true
  },
]
